import { useGetAllAgencies } from '@urbanx/agx.agencies.client';
import { AgencyContext } from 'contexts';
import useAgencyIdParam from 'hooks/useAgencyIdParam';
import { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const AgencyPage = () => {
  const [, setSelectedAgency] = useContext(AgencyContext);

  const agencyId = useAgencyIdParam();

  const { data: agencies } = useGetAllAgencies();

  useEffect(() => {
    if (!agencyId) return;

    const agency = agencies?.find((a) => a.id === agencyId);
    setSelectedAgency(agency);
  }, [agencyId, agencies]);

  return <Outlet />;
};

export default AgencyPage;
